export default "__VITE_ASSET__babc2219__"